import { useEffect, useState } from 'react';

import cx from 'classnames';

import { CrossIcon } from '@motorway/mw-highway-code';
import { LoadingIndicator } from '@motorway/mw-highway-code/alpha';

import { useUploadImage } from '@motorway/motorway-handshake-components';
import type { ImageUpload } from '@motorway/motorway-handshake-components/types';

import styles from './ImageThumbnail.module.scss';

export const ImageThumbnail = ({ data, deleteImage }: {
  data: ImageUpload;
  deleteImage: (data: ImageUpload) => void;
}) => {
  const { uploadUrl } = data;
  const { uploadUrl: finalUploadUrl } = uploadUrl ?? {};

  const [loading, setLoading] = useState(!!finalUploadUrl);

  const { progress, upload } = useUploadImage();

  useEffect(() => {
    if (!finalUploadUrl || !data.file) {
      return;
    }

    upload({ file: data.file, uploadUrl: finalUploadUrl });
  }, [finalUploadUrl]);

  useEffect(() => {
    if (progress === 100) {
      setLoading(false);
    }
  }, [progress]);

  return (
    <div className={cx(styles.component, { [styles.loading]: loading })}>
      <div className={styles.thumbnail}>
        <img src={data.url} alt="Uploaded" className={styles.image} />
        {loading && (
          <span className={styles.progress}><em style={{ width: `${progress}%` }}></em></span>
        )}
      </div>
      <div className={styles.delete} onClick={() => { deleteImage(data); }}>
        {
          loading ? <LoadingIndicator /> : <CrossIcon />
        }
      </div>
    </div>
  );
};
